<nav class="navbar navbar-expang-lg navbar-light bg-light border-bottom">
    <span class="navbar-brand mr-auto">
      {{ pageTitle }}
    </span>
</nav>